import { FilterService } from "primevue/api";

console.log("filters registered");

FilterService.register("isDateBetween", (value, range, filter) => {
  return filter > range[0] && filter < range[1];
});
